import { render, staticRenderFns } from "./AlreadyHaveProduct.vue?vue&type=template&id=8b4f8a76&"
import script from "./AlreadyHaveProduct.vue?vue&type=script&lang=js&"
export * from "./AlreadyHaveProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports